import { KpiDashboardData } from "../../pages/Dashboard/ChatJess/components/KpiPanel/types";

export const mockKpiDashboardData: KpiDashboardData = {
  agentName: "Jess",
  lastUpdatedAt: new Date().toISOString(),
  categories: [
    {
      id: "communication",
      label: { en: "Communication", pt: "Comunicação", es: "Comunicación" },
      kpis: [
        {
          id: "messages-handled",
          label: {
            en: "Messages Handled",
            pt: "Mensagens Atendidas",
            es: "Mensajes Atendidos",
          },
          value: 847,
          valueType: "number",
          trend: "up",
          trendValue: "+12%",
          comparison: "previous_week",
          status: "positive",
          icon: "fas fa-comments",
          description: {
            en: "Total messages processed by Jess this week",
            pt: "Total de mensagens processadas pela Jess nesta semana",
            es: "Total de mensajes procesados por Jess esta semana",
          },
        },
        {
          id: "active-conversations",
          label: {
            en: "Active Conversations",
            pt: "Conversas Ativas",
            es: "Conversaciones Activas",
          },
          value: 12,
          valueType: "number",
          trend: "neutral",
          status: "neutral",
          icon: "fas fa-message",
          description: "Conversas em andamento no momento",
        },
        {
          id: "avg-response-time",
          label: "Tempo Médio de Resposta",
          value: "1.2s",
          valueType: "duration",
          trend: "down",
          trendValue: "-8%",
          comparison: "previous_week",
          status: "positive",
          icon: "fas fa-clock",
          description: "Tempo médio que a Jess leva para responder",
        },
      ],
    },
    {
      id: "performance",
      label: { en: "Performance", pt: "Desempenho", es: "Rendimiento" },
      kpis: [
        {
          id: "resolution-rate",
          label: {
            en: "Resolution Rate",
            pt: "Taxa de Resolução",
            es: "Tasa de Resolución",
          },
          value: 94.5,
          valueType: "percentage",
          trend: "up",
          trendValue: "+3.2%",
          comparison: "previous_week",
          status: "positive",
          icon: "fas fa-check-circle",
          description: "Percentual de conversas resolvidas sem escalação",
        },
        {
          id: "tasks-completed",
          label: "Tarefas Concluídas",
          value: 156,
          valueType: "number",
          trend: "up",
          trendValue: "+18",
          comparison: "previous_day",
          status: "positive",
          icon: "fas fa-tasks",
          description: "Tarefas finalizadas pela Jess",
        },
        {
          id: "escalation-rate",
          label: {
            en: "Escalation Rate",
            pt: "Taxa de Escalação",
            es: "Tasa de Escalación",
          },
          value: 5.5,
          valueType: "percentage",
          trend: "down",
          trendValue: "-1.2%",
          comparison: "previous_week",
          status: "positive",
          icon: "fas fa-arrow-up-right-from-square",
          description: "Percentual de conversas escaladas para humanos",
        },
      ],
    },
    {
      id: "satisfaction",
      label: { en: "Satisfaction", pt: "Satisfação", es: "Satisfacción" },
      kpis: [
        {
          id: "customer-satisfaction",
          label: {
            en: "Customer Satisfaction",
            pt: "Satisfação do Cliente",
            es: "Satisfacción del Cliente",
          },
          value: 92.3,
          valueType: "percentage",
          trend: "up",
          trendValue: "+2.1%",
          comparison: "previous_week",
          status: "positive",
          icon: "fas fa-face-smile",
          description: "Índice de satisfação dos clientes atendidos",
        },
        {
          id: "cost-savings",
          label: {
            en: "Cost Savings",
            pt: "Economia Estimada",
            es: "Ahorro Estimado",
          },
          value: 2450,
          valueType: "currency",
          trend: "up",
          trendValue: "+15%",
          comparison: "previous_month",
          status: "positive",
          icon: "fas fa-piggy-bank",
          description: "Economia estimada com atendimento automatizado",
        },
      ],
    },
  ],
  summary: {
    label: {
      en: "Resolution Rate",
      pt: "Taxa de Resolução",
      es: "Tasa de Resolución",
    },
    value: "94.5%",
    valueType: "percentage",
  },
};
